
import { Vue, prop, Options } from "vue-class-component";
import DonutChart from "@/app/ui/components/donut-chart/index.vue";
import Skeleton from "@/app/ui/components/skeleton/index.vue";

class Prop {
  totalCompleted = prop({
    type: Number,
    default: 0
  });
  totalActivities = prop({
    type: Number,
    default: 0
  });
  totalPending = prop({
    type: Number,
    default: 0
  });
  isLoading = prop({
    type: Boolean,
    default: false
  });
}

@Options({
  name: "CardProgress",
  components: {
    Skeleton,
    DonutChart
  }
})
class CardProgress extends Vue.with(Prop) {
  get progress() {
    if (this.totalPending === 0) {
      return 100;
    }
    return Math.round(this.totalCompleted / this.totalActivities * 100);
  }
  get chartData() {
    if (this.totalPending === 0) {
      return [1, 0];
    }
    return [this.totalCompleted,this.totalPending];
  }
  chartColor = ["#36B37E", "#F00"];
}
export default CardProgress;
